import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { StateService } from 'src/app/state.service';
import { IChangePasswordFormGroup } from './IChangePasswordFormGroup';

export const StrongPasswordRegx: RegExp =
  /^(?=[^a-z]*[a-z])(?=\D*\d).{8,}$/;

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent  implements OnInit, OnDestroy {
    
  //catch changes on sessionId
  private userNameSubscription: Subscription;
  public showPassword: boolean;
       
  public itemStyle: string = '';
  
  changePasswordForm: UntypedFormGroup = new UntypedFormGroup({});

  @Input() userNameLogin: string;
  @Input() changeUserPassword: boolean = false;
  @Input() userId: string;

  constructor(
      private formBuilder: FormBuilder,
      private stateService: StateService
  ) { }

  ngOnInit() {
      this.changePasswordForm = this.formBuilder.group({
          username: [{value: '', disabled: true}, Validators.required],
          password: ['', !this.changeUserPassword ? Validators.required : null ] ,
          newPassword: ['', [Validators.required, Validators.pattern(StrongPasswordRegx)]],
          newPasswordRepeat: ['', [Validators.required] ]
        },
        { validator: checkMatchValidator('newPassword', 'newPasswordRepeat') }) as IChangePasswordFormGroup;
      
        if (this.changeUserPassword)
        {
          this.f['username'].setValue(this.userNameLogin);
        }
        else
        {
          this.userNameSubscription = this.stateService.userNameLogin$.subscribe((userName) =>
          {
            this.f['username'].setValue(userName);
          })
        }
        
  }


  ngOnDestroy(): void {
      if (this.userNameSubscription) this.userNameSubscription.unsubscribe();
  }

  // convenience getter for easy access to form fields
  get f() { return this.changePasswordForm.controls; }

  onSubmit() {
      
      // stop here if form is invalid
      if (this.changePasswordForm.invalid) {
          return;
      }

      if (this.changeUserPassword)
      {
        this.stateService.changeUserPassword(this.userId, this.f['username'].value, this.f['newPassword'].value, );
      }
      else 
      {
        this.stateService.changeOwnPassword(this.f['username'].value, this.f['password'].value, this.f['newPassword'].value);               
      }
  }
}

  export function checkMatchValidator(field1: string, field2: string) {
    return function (frm) {
      let field1Value = frm.get(field1).value;
      let field2Value = frm.get(field2).value;
  
      if (field1Value !== '' && field1Value !== field2Value) {
        
        return { 'newPasswordsNoMatch': `true` }
      }
      return null;
    }
  }
 
